export default __webpack_public_path__ + "static/media/153-USA.0d34f81b.svg";